import React from 'react';
import * as PlayiitATApi from '../apis/PlayiitATApi.js';
import { ButtonSolid, ScreenContainer, withTheme } from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import * as WebBrowser from 'expo-web-browser';
import {
  ActivityIndicator,
  FlatList,
  Image,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { Fetch } from 'react-request';

const SongdetailScreen = props => {
  const { theme } = props;

  const {
    isLoading: screenLoading,
    data: screenData,
    error: screenError,
  } = PlayiitATApi.useSINGLE$GET$GET({
    id: props.route?.params?.id ?? 'rec2whmxq29O4SEvS',
  });

  if (screenLoading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator />
      </View>
    );
  }

  if (screenError) {
    return null;
  }

  if (!screenData) {
    return null;
  }

  return (
    <ScreenContainer
      style={{ borderRadius: 0, borderColor: theme.colors.strong }}
      scrollable={true}
    >
      <PlayiitATApi.FetchSINGLE$GET$GET id={screenData?.id}>
        {({ loading, error, data, doFetch }) => {
          const fetchData = data;
          if (!fetchData || loading) {
            return <ActivityIndicator />;
          }

          if (error) {
            return (
              <Text style={{ textAlign: 'center' }}>
                There was a problem fetching this data
              </Text>
            );
          }

          return (
            <View style={styles.ViewFo} pointerEvents={'auto'}>
              <Text style={[styles.Textia, { color: theme.colors.strong }]}>
                {fetchData?.fields && fetchData?.fields['Song Name']}
              </Text>

              <Text style={{ color: theme.colors.strong }}>
                {'By : '}
                {fetchData?.fields?.Artist}
              </Text>

              <Text style={{ color: theme.colors.strong }}>
                {'Chords used : '}
                {fetchData?.fields && fetchData?.fields['Chords Used']}
              </Text>

              <Text style={[styles.Textvu, { color: theme.colors.strong }]}>
                {fetchData?.fields?.Tags}
              </Text>
              <ButtonSolid
                onPress={async () => {
                  try {
                    await WebBrowser.openBrowserAsync(
                      `${fetchData?.fields?.YouTubeLink}`
                    );
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidaV,
                  { backgroundColor: theme.colors.primary },
                ]}
                title={'View video on YouTube'}
              />
              <ButtonSolid
                onPress={async () => {
                  try {
                    await WebBrowser.openBrowserAsync(
                      `${fetchData?.fields && fetchData?.fields['Free paid']}`
                    );
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={[
                  styles.ButtonSolidjU,
                  { backgroundColor: theme.colors.primary },
                ]}
                title={'Download SGU'}
              />
              <View style={styles.View_7Y} pointerEvents={'auto'}>
                <FlatList
                  data={fetchData?.fields?.Thumbnail}
                  renderItem={({ item }) => {
                    const listData = item;
                    return (
                      <>
                        <Image
                          style={styles.Imageq4}
                          source={{ uri: `${listData && listData['url']}` }}
                          resizeMode={'cover'}
                        />
                        <Text
                          style={[
                            styles.Text_0X,
                            { color: theme.colors.strong },
                          ]}
                        >
                          {'Chords and Lyrics'}
                        </Text>

                        <Text
                          style={[
                            styles.TextoI,
                            { color: theme.colors.strong },
                          ]}
                        >
                          {fetchData?.fields &&
                            fetchData?.fields['Chords and Lyrics']}
                        </Text>
                      </>
                    );
                  }}
                  contentContainerStyle={styles.FlatListnyContent}
                  numColumns={1}
                />
              </View>
            </View>
          );
        }}
      </PlayiitATApi.FetchSINGLE$GET$GET>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  Textia: {
    fontFamily: 'System',
    fontWeight: '700',
    fontSize: 18,
  },
  Textvu: {
    marginLeft: 10,
    marginRight: 10,
  },
  ButtonSolidaV: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  ButtonSolidjU: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 10,
  },
  Imageq4: {
    width: 400,
    height: 250,
  },
  Text_0X: {
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  TextoI: {
    marginLeft: 10,
    marginRight: 20,
    paddingRight: 10,
    textAlign: 'center',
    alignSelf: 'center',
  },
  FlatListnyContent: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  View_7Y: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  ViewFo: {
    width: '100%',
    height: '18%',
    marginRight: 20,
    alignItems: 'center',
    flex: 1,
    paddingTop: 10,
    marginBottom: 10,
  },
  FetchBA: {
    minHeight: 40,
  },
});

export default withTheme(SongdetailScreen);
